// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--Xcmjv","text":"a10a3f92e9--text--RGs9l","icon":"a10a3f92e9--icon--JQjK8","secondary":"a10a3f92e9--secondary--_8Y09"};